import { Chip, Tooltip } from '@mui/material';

type PlanTier = 'free' | 'pro' | 'enterprise';

interface PlanChipProps {
  plan: PlanTier;
  commercialName?: string;
  size?: 'small' | 'medium';
}

const PLAN_COLORS: Record<PlanTier, 'default' | 'primary' | 'secondary'> = {
  free: 'default',
  pro: 'primary',
  enterprise: 'secondary',
};

export default function PlanChip({
  plan,
  commercialName,
  size = 'small',
}: PlanChipProps) {
  return (
    <Tooltip
      title={
        commercialName
          ? 'Plano da assinatura atribuída no Management'
          : 'A instância mantém o acesso existente até receber uma assinatura. Isso não indica a versão da aplicação.'
      }
    >
      <Chip
        label={commercialName || 'Sem assinatura atribuída'}
        color={commercialName ? PLAN_COLORS[plan] : 'default'}
        size={size}
        sx={{ maxWidth: '100%' }}
      />
    </Tooltip>
  );
}
